import { render, staticRenderFns } from "./AlertDotted.vue?vue&type=template&id=1245ba5c&scoped=true"
import script from "./AlertDotted.vue?vue&type=script&lang=js"
export * from "./AlertDotted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1245ba5c",
  null
  
)

export default component.exports